import React from 'react';

import { Select, SelectPropsT } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/select.scss';

export type NcSelectPropsT = SelectPropsT & {
  id: string;
};
export type NcSelectT = React.FC<NcSelectPropsT>;

export const NcSelect: NcSelectT = ({ className, ...props }) => {
  const classNames = `nc-select ${className || ''}`;

  return <Select className={classNames} {...props} />;
};
